"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./messages/util");

var CardInfoEntryIndicator;

(function (CardInfoEntryIndicator) {
  CardInfoEntryIndicator[CardInfoEntryIndicator["Keyed"] = 0] = "Keyed";
  CardInfoEntryIndicator[CardInfoEntryIndicator["Swiped"] = 1] = "Swiped";
  CardInfoEntryIndicator[CardInfoEntryIndicator["TapMSD"] = 2] = "TapMSD";
  CardInfoEntryIndicator[CardInfoEntryIndicator["TapEMV"] = 3] = "TapEMV";
  CardInfoEntryIndicator[CardInfoEntryIndicator["BarCode"] = 4] = "BarCode";
  CardInfoEntryIndicator[CardInfoEntryIndicator["EMVContact"] = 5] = "EMVContact";
  CardInfoEntryIndicator[CardInfoEntryIndicator["QRCode"] = 6] = "QRCode";
})(CardInfoEntryIndicator = exports.CardInfoEntryIndicator || (exports.CardInfoEntryIndicator = {}));

var CardInReader;

(function (CardInReader) {
  CardInReader[CardInReader["NoCardInReader"] = 0] = "NoCardInReader";
  CardInReader[CardInReader["CardInReader"] = 1] = "CardInReader";
})(CardInReader = exports.CardInReader || (exports.CardInReader = {}));

exports.CardInReaderLookupMap = util_1.reverseLookupMapForEnum(CardInReader); // card type mappings
// @todo add more card types

var CardType;

(function (CardType) {
  CardType[CardType["MASTERCARD"] = 49] = "MASTERCARD";
  CardType[CardType["VISA"] = 50] = "VISA";
  CardType[CardType["AMEX"] = 51] = "AMEX";
  CardType[CardType["DISCOVER"] = 52] = "DISCOVER";
  CardType[CardType["GIFT_CARD"] = 80] = "GIFT_CARD";
})(CardType = exports.CardType || (exports.CardType = {}));

var Cvv2Indicator;

(function (Cvv2Indicator) {
  Cvv2Indicator[Cvv2Indicator["NotProvided"] = 0] = "NotProvided";
  Cvv2Indicator[Cvv2Indicator["Present"] = 1] = "Present";
  Cvv2Indicator[Cvv2Indicator["Ineligible"] = 2] = "Ineligible";
  Cvv2Indicator[Cvv2Indicator["NotOnCard"] = 9] = "NotOnCard";
})(Cvv2Indicator = exports.Cvv2Indicator || (exports.Cvv2Indicator = {}));
/**
 * ISO-4217 currency codes - letter to numeric mapping
 * @todo add more currency codes
 * @see {@link https://www.iso.org/iso-4217-currency-codes.html}
 */


var CurrencyCode;

(function (CurrencyCode) {
  CurrencyCode["CAD"] = "124";
  CurrencyCode["USD"] = "840";
  CurrencyCode["GBP"] = "826";
  CurrencyCode["CHF"] = "756";
  CurrencyCode["ZAR"] = "710";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));

var DeviceStatusRequestIndicator;

(function (DeviceStatusRequestIndicator) {
  // No action performed
  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["NoAction"] = 0] = "NoAction"; // request current pin pad status only
  // no "check" is performed

  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["CurrentStatusNoCheck"] = 1] = "CurrentStatusNoCheck"; // request current pin pad status and
  // perform a "check"

  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["CurrentStatusWithCheck"] = 2] = "CurrentStatusWithCheck"; // request current pin pad status with
  // device serial number

  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["CurrentStatusWithSerial"] = 3] = "CurrentStatusWithSerial"; // Cancel Card entry - this is only
  // supported on 'selected pin pads'
  // use with caution

  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["CancelCardEntry"] = 4] = "CancelCardEntry"; // Check for card in reader

  DeviceStatusRequestIndicator[DeviceStatusRequestIndicator["CardInReaderCheck"] = 8] = "CardInReaderCheck";
})(DeviceStatusRequestIndicator = exports.DeviceStatusRequestIndicator || (exports.DeviceStatusRequestIndicator = {}));
/**
 * This indicator must be provided to utilize
 * certain actions on Device Status requests.
 */


var DeviceTypeActionIndicator;

(function (DeviceTypeActionIndicator) {
  DeviceTypeActionIndicator[DeviceTypeActionIndicator["NoDeviceSelected"] = 0] = "NoDeviceSelected";
  DeviceTypeActionIndicator[DeviceTypeActionIndicator["E355"] = 2] = "E355";
  DeviceTypeActionIndicator[DeviceTypeActionIndicator["MxVxOrIngenico"] = 7] = "MxVxOrIngenico";
})(DeviceTypeActionIndicator = exports.DeviceTypeActionIndicator || (exports.DeviceTypeActionIndicator = {}));

var DuplicateLevelCheckIndicator;

(function (DuplicateLevelCheckIndicator) {
  DuplicateLevelCheckIndicator[DuplicateLevelCheckIndicator["NoCheck"] = 0] = "NoCheck";
  DuplicateLevelCheckIndicator[DuplicateLevelCheckIndicator["NoDuplicateAllowedInCurrentOpenBatch"] = 1] = "NoDuplicateAllowedInCurrentOpenBatch";
  DuplicateLevelCheckIndicator[DuplicateLevelCheckIndicator["DuplicateAllowedInCurrentOpenBatchOnFirstTransaction"] = 2] = "DuplicateAllowedInCurrentOpenBatchOnFirstTransaction";
})(DuplicateLevelCheckIndicator = exports.DuplicateLevelCheckIndicator || (exports.DuplicateLevelCheckIndicator = {}));

var ECommerceGoodsIndicator;

(function (ECommerceGoodsIndicator) {
  ECommerceGoodsIndicator[ECommerceGoodsIndicator["Digital"] = 0] = "Digital";
  ECommerceGoodsIndicator[ECommerceGoodsIndicator["Physical"] = 1] = "Physical";
})(ECommerceGoodsIndicator = exports.ECommerceGoodsIndicator || (exports.ECommerceGoodsIndicator = {}));

var Encoding;

(function (Encoding) {
  Encoding["ascii"] = "ascii";
  Encoding["utf8"] = "utf-8";
})(Encoding = exports.Encoding || (exports.Encoding = {}));

var FieldJustification;

(function (FieldJustification) {
  FieldJustification["left"] = "left";
  FieldJustification["right"] = "right";
})(FieldJustification = exports.FieldJustification || (exports.FieldJustification = {}));

var FieldType;

(function (FieldType) {
  FieldType["alphaNumeric"] = "alphaNumeric";
  FieldType["base64"] = "base64";
  FieldType["fixed"] = "fixed";
  FieldType["float"] = "float";
  FieldType["numeric"] = "numeric";
  FieldType["reserved"] = "reserved";
})(FieldType = exports.FieldType || (exports.FieldType = {}));

var GiftCardEntryMethodIndicator;

(function (GiftCardEntryMethodIndicator) {
  GiftCardEntryMethodIndicator["Scanned"] = "B";
  GiftCardEntryMethodIndicator["Swiped"] = "M";
})(GiftCardEntryMethodIndicator = exports.GiftCardEntryMethodIndicator || (exports.GiftCardEntryMethodIndicator = {}));

var HostStatus;

(function (HostStatus) {
  HostStatus[HostStatus["NotConnected"] = 0] = "NotConnected";
  HostStatus[HostStatus["Connected"] = 1] = "Connected";
  HostStatus[HostStatus["ConnectionAttemptSuccess"] = 2] = "ConnectionAttemptSuccess";
  HostStatus[HostStatus["ConnectionAttemptFail"] = 3] = "ConnectionAttemptFail";
  HostStatus[HostStatus["InformationNotAvailable"] = 99] = "InformationNotAvailable";
})(HostStatus = exports.HostStatus || (exports.HostStatus = {}));

exports.HostStatusLookupMap = util_1.reverseLookupMapForEnum(HostStatus);
var HostGiftStatus;

(function (HostGiftStatus) {
  HostGiftStatus[HostGiftStatus["NotConnected"] = 0] = "NotConnected";
  HostGiftStatus[HostGiftStatus["Connected"] = 1] = "Connected";
  HostGiftStatus[HostGiftStatus["ConnectionAttemptSuccess"] = 2] = "ConnectionAttemptSuccess";
  HostGiftStatus[HostGiftStatus["ConnectionAttemptFail"] = 3] = "ConnectionAttemptFail";
  HostGiftStatus[HostGiftStatus["InformationNotAvailable"] = 99] = "InformationNotAvailable";
})(HostGiftStatus = exports.HostGiftStatus || (exports.HostGiftStatus = {}));

exports.HostGiftStatusLookupMap = exports.HostStatusLookupMap;
var HostStatusRequestIndicator;

(function (HostStatusRequestIndicator) {
  HostStatusRequestIndicator[HostStatusRequestIndicator["NoAction"] = 0] = "NoAction";
  /**
   * Returns current status of connection,
   * without testing the connection
   */

  HostStatusRequestIndicator[HostStatusRequestIndicator["CurrentStatusNoCheck"] = 1] = "CurrentStatusNoCheck";
  /**
   * Performs a check of the current
   * connection to host and returns the status
   */

  HostStatusRequestIndicator[HostStatusRequestIndicator["CurrentStatusWithCheck"] = 2] = "CurrentStatusWithCheck";
})(HostStatusRequestIndicator = exports.HostStatusRequestIndicator || (exports.HostStatusRequestIndicator = {}));

var InstallmentIndicator;

(function (InstallmentIndicator) {
  InstallmentIndicator["Installment"] = "I";
  InstallmentIndicator["Recurring"] = "1";
})(InstallmentIndicator = exports.InstallmentIndicator || (exports.InstallmentIndicator = {}));

var LastTransactionStatus;

(function (LastTransactionStatus) {
  LastTransactionStatus["Approved"] = "A";
  LastTransactionStatus["ApprovedOffline"] = "F";
  LastTransactionStatus["Declined"] = "D";
  LastTransactionStatus["Error"] = "E";
  LastTransactionStatus["NoData"] = "N";
  LastTransactionStatus["PreApproved"] = "I";
  LastTransactionStatus["Reversed"] = "R";
})(LastTransactionStatus = exports.LastTransactionStatus || (exports.LastTransactionStatus = {}));

exports.LastTransactionStatusLookupMap = util_1.reverseLookupMapForEnum(LastTransactionStatus);
/**
 * when the card data is provided by the user
 * rather than obtained from a swipe we must provide
 * a payment type if possible (or Unspecified if unknown)
 */

var PaymentTypeIndicator;

(function (PaymentTypeIndicator) {
  PaymentTypeIndicator[PaymentTypeIndicator["Unspecified"] = 0] = "Unspecified";
  PaymentTypeIndicator[PaymentTypeIndicator["MasterCard"] = 1] = "MasterCard";
  PaymentTypeIndicator[PaymentTypeIndicator["Visa"] = 2] = "Visa";
  PaymentTypeIndicator[PaymentTypeIndicator["Amex"] = 3] = "Amex";
  PaymentTypeIndicator[PaymentTypeIndicator["Discover"] = 4] = "Discover";
  PaymentTypeIndicator[PaymentTypeIndicator["Diners"] = 6] = "Diners";
  PaymentTypeIndicator[PaymentTypeIndicator["JCB"] = 7] = "JCB";
  PaymentTypeIndicator[PaymentTypeIndicator["PrivateLabel"] = 8] = "PrivateLabel";
  PaymentTypeIndicator[PaymentTypeIndicator["VisaDebit"] = 20] = "VisaDebit";
  PaymentTypeIndicator[PaymentTypeIndicator["MasterCardUSDebit"] = 22] = "MasterCardUSDebit";
  PaymentTypeIndicator[PaymentTypeIndicator["DiscoverUSDebit"] = 24] = "DiscoverUSDebit";
  PaymentTypeIndicator[PaymentTypeIndicator["VisaUSDebit"] = 25] = "VisaUSDebit";
  PaymentTypeIndicator[PaymentTypeIndicator["VisaChaseNet"] = 26] = "VisaChaseNet";
  PaymentTypeIndicator[PaymentTypeIndicator["GiftCard"] = 32] = "GiftCard";
  PaymentTypeIndicator[PaymentTypeIndicator["LoyaltyCard"] = 33] = "LoyaltyCard";
  PaymentTypeIndicator[PaymentTypeIndicator["AliPay"] = 34] = "AliPay";
  PaymentTypeIndicator[PaymentTypeIndicator["WeChat"] = 35] = "WeChat";
  PaymentTypeIndicator[PaymentTypeIndicator["FleetCard"] = 42] = "FleetCard";
})(PaymentTypeIndicator = exports.PaymentTypeIndicator || (exports.PaymentTypeIndicator = {}));
/**
 * Pin Pad Action1 actions are only
 * available if sending the Device
 * Type indicator 2, with the exception
 * of ResetDeviceType7 which can only be
 * used with Device Type indicator 7
 * (these actions may not work on all devices)
 */


var PinPadAction1Indicator;

(function (PinPadAction1Indicator) {
  PinPadAction1Indicator[PinPadAction1Indicator["NoAction"] = 0] = "NoAction";
  /**
   * Used to enable PinPad Action2 Flag field.
   */

  PinPadAction1Indicator[PinPadAction1Indicator["ChangeConfiguration"] = 1] = "ChangeConfiguration";
  PinPadAction1Indicator[PinPadAction1Indicator["ResetDevice"] = 2] = "ResetDevice";
  PinPadAction1Indicator["ResetDeviceType7"] = "R";
})(PinPadAction1Indicator = exports.PinPadAction1Indicator || (exports.PinPadAction1Indicator = {}));
/**
 * Pin pad Action2 can be used to modify
 * configuration values if the value of
 * Pin Pad Action1 is "ChangeConfiguration"
 *
 * These actions are only supported for devices
 * with mounted barcode scanners, @see PinPadAction3IndicatorContinuousMode
 * and @see PinPadAction3IndicatorAutoBeepMode
 */


var PinPadAction2Indicator;

(function (PinPadAction2Indicator) {
  PinPadAction2Indicator[PinPadAction2Indicator["NoAction"] = 0] = "NoAction";
  PinPadAction2Indicator[PinPadAction2Indicator["ContinuousMode"] = 1] = "ContinuousMode";
  PinPadAction2Indicator[PinPadAction2Indicator["AutoBeepMode"] = 2] = "AutoBeepMode";
  PinPadAction2Indicator[PinPadAction2Indicator["SymbologyParameters"] = 3] = "SymbologyParameters";
})(PinPadAction2Indicator = exports.PinPadAction2Indicator || (exports.PinPadAction2Indicator = {}));
/**
 * These indicators can be used with PinPadAction2Indicator
 * in ContinuousMode
 */


var PinPadAction3IndicatorContinuousMode;

(function (PinPadAction3IndicatorContinuousMode) {
  PinPadAction3IndicatorContinuousMode["Disable"] = "00";
  PinPadAction3IndicatorContinuousMode["Enable"] = "01";
})(PinPadAction3IndicatorContinuousMode = exports.PinPadAction3IndicatorContinuousMode || (exports.PinPadAction3IndicatorContinuousMode = {}));
/**
 * These indicators can be used with
 * PinPadAction2Indicator.AutoBeepMode
 */


var PinPadAction3IndicatorAutoBeepMode;

(function (PinPadAction3IndicatorAutoBeepMode) {
  PinPadAction3IndicatorAutoBeepMode["Disable"] = "00";
  PinPadAction3IndicatorAutoBeepMode["Enable"] = "01";
  PinPadAction3IndicatorAutoBeepMode["ErrorBeep"] = "02";
  PinPadAction3IndicatorAutoBeepMode["ScanBeep"] = "03";
})(PinPadAction3IndicatorAutoBeepMode = exports.PinPadAction3IndicatorAutoBeepMode || (exports.PinPadAction3IndicatorAutoBeepMode = {}));
/**
 * these Indicators can be used with
 * PinPadAction2Indicator.SymbologyParameters
 */


var PinPadAction3IndicatorSymbologyParameters;

(function (PinPadAction3IndicatorSymbologyParameters) {
  /**
   * Default
   */
  PinPadAction3IndicatorSymbologyParameters[PinPadAction3IndicatorSymbologyParameters["Code128"] = 0] = "Code128";
  /**
   * @todo define other symbology parameters as needed
   */
})(PinPadAction3IndicatorSymbologyParameters = exports.PinPadAction3IndicatorSymbologyParameters || (exports.PinPadAction3IndicatorSymbologyParameters = {}));
/**
 * used in conjunction with
 * PinPadAction3IndicatorSymbologyParameters
 * to enable or disable symbology
 */


var PinPadAction4Indicator;

(function (PinPadAction4Indicator) {
  PinPadAction4Indicator[PinPadAction4Indicator["Disable"] = 0] = "Disable";
  PinPadAction4Indicator[PinPadAction4Indicator["Enable"] = 1] = "Enable";
})(PinPadAction4Indicator = exports.PinPadAction4Indicator || (exports.PinPadAction4Indicator = {}));

var PinPadStatus;

(function (PinPadStatus) {
  PinPadStatus[PinPadStatus["NotPresent"] = 0] = "NotPresent";
  PinPadStatus[PinPadStatus["OK"] = 1] = "OK";
  PinPadStatus[PinPadStatus["Error"] = 2] = "Error";
  PinPadStatus[PinPadStatus["Busy"] = 3] = "Busy";
  PinPadStatus[PinPadStatus["NotConnected"] = 4] = "NotConnected";
  PinPadStatus[PinPadStatus["CannotConnect"] = 5] = "CannotConnect";
  PinPadStatus[PinPadStatus["InformationNotAvailable"] = 99] = "InformationNotAvailable";
})(PinPadStatus = exports.PinPadStatus || (exports.PinPadStatus = {}));

exports.PinPadStatusLookupMap = util_1.reverseLookupMapForEnum(PinPadStatus); // delimiter characters used in responses

var ResponseDelimiter;

(function (ResponseDelimiter) {
  ResponseDelimiter["ACK"] = "\u0006";
  ResponseDelimiter["Colon"] = ":";
  ResponseDelimiter["CRLF"] = "\r\n";
  ResponseDelimiter["ETX"] = "\u0003";
  ResponseDelimiter["FS"] = "\u001C";
  ResponseDelimiter["NAK"] = "\u0015";
  ResponseDelimiter["STX"] = "\u0002";
})(ResponseDelimiter = exports.ResponseDelimiter || (exports.ResponseDelimiter = {})); // response keys to readable keys mapping


var ResponseKey;

(function (ResponseKey) {
  ResponseKey["AMT"] = "amountRequested";
  ResponseKey["AUT"] = "authorizationNumber";
  ResponseKey["AVS"] = "avsResponse";
  ResponseKey["BIN"] = "cardBin";
  ResponseKey["CBK"] = "cashBackAmount";
  ResponseKey["CFV"] = "ctlFirmwareVersion";
  ResponseKey["CLV"] = "coreLibraryVersion";
  ResponseKey["CRN"] = "cardNumber";
  ResponseKey["CRT"] = "creditType";
  ResponseKey["CVD"] = "cvdResponse";
  ResponseKey["DAT"] = "date";
  ResponseKey["EHL"] = "echoLotteryStatus";
  ResponseKey["EKV"] = "emvKernelVersion";
  ResponseKey["EXP"] = "expirationDate";
  ResponseKey["HGS"] = "hostGiftStatus";
  ResponseKey["HSS"] = "hostStatus";
  ResponseKey["INV"] = "invoiceNumber";
  ResponseKey["LNG"] = "language";
  ResponseKey["LTS"] = "lastTransactionStatus";
  ResponseKey["MOD"] = "deviceModelName";
  ResponseKey["MRC"] = "merchantId";
  ResponseKey["OPR"] = "operatorId";
  ResponseKey["PAV"] = "applicationVersion";
  ResponseKey["PPN"] = "pinPadName";
  ResponseKey["PPS"] = "pinPadStatus";
  ResponseKey["PSN"] = "pinPadSerialNumber";
  ResponseKey["PYT"] = "paymentType";
  ResponseKey["RBA"] = "remainingBalance";
  ResponseKey["RCP"] = "receiptLine";
  ResponseKey["REF"] = "transactionNumber";
  ResponseKey["RES"] = "result";
  ResponseKey["ROV"] = "romOsVersion";
  ResponseKey["SEQ"] = "sequenceNumber";
  ResponseKey["SWP"] = "inputMethod";
  ResponseKey["RRT"] = "remainingDeviceAutoRebootTime";
  ResponseKey["TAT"] = "totalTransactionAmount";
  ResponseKey["TIM"] = "time";
  ResponseKey["TIP"] = "tipAmount";
  ResponseKey["TOC"] = "fallbackToken";
  ResponseKey["TOK"] = "token";
  ResponseKey["TRM"] = "terminalId";
  ResponseKey["TRS"] = "terminalStatus";
  ResponseKey["TYP"] = "transactionType";
  ResponseKey["VRC"] = "cdcaMDllVersion";
  ResponseKey["VRD"] = "hostDriverVersion";
  ResponseKey["VRM"] = "multiExeVersion";
})(ResponseKey = exports.ResponseKey || (exports.ResponseKey = {})); // response status codes
// @todo add more status codes
// there are a lot


var ResponseStatusCode;

(function (ResponseStatusCode) {
  ResponseStatusCode["Declined"] = "0[48]";
  ResponseStatusCode["Approved"] = "1[49]";
  ResponseStatusCode["ApprovedOffline"] = "2[50]";
  ResponseStatusCode["CardEntryCanceled"] = "h[104]";
  ResponseStatusCode["CardEntryTimeOut"] = "i[105]";
  ResponseStatusCode["PinPadInputError"] = "G[71]";
  ResponseStatusCode["InvalidCard"] = "F[70]";
  ResponseStatusCode["InvalidCardNumber"] = "H[72]";
  ResponseStatusCode["TimeOut"] = "J[74]";
  ResponseStatusCode["TransactionNotSupported"] = "Z[90]";
})(ResponseStatusCode = exports.ResponseStatusCode || (exports.ResponseStatusCode = {})); // reverse-lookup map for ResponseStatusCode


exports.ResponseStatusCodeLookupMap = util_1.reverseLookupMapForEnum(ResponseStatusCode);
var ReturnVersionRequestIndicator;

(function (ReturnVersionRequestIndicator) {
  /**
   * Do not return version
   */
  ReturnVersionRequestIndicator[ReturnVersionRequestIndicator["NoAction"] = 0] = "NoAction";
  /**
   * Return version for given terminal ID
   */

  ReturnVersionRequestIndicator[ReturnVersionRequestIndicator["VersionForTerminal"] = 1] = "VersionForTerminal";
})(ReturnVersionRequestIndicator = exports.ReturnVersionRequestIndicator || (exports.ReturnVersionRequestIndicator = {}));

var LastTransactionStatusRequestIndicator;

(function (LastTransactionStatusRequestIndicator) {
  LastTransactionStatusRequestIndicator[LastTransactionStatusRequestIndicator["NoAction"] = 0] = "NoAction";
  /**
   * Return Last Transaction status only
   */

  LastTransactionStatusRequestIndicator[LastTransactionStatusRequestIndicator["StatusOnly"] = 1] = "StatusOnly";
  /**
   * Return Last Transaction status and receipt
   */

  LastTransactionStatusRequestIndicator[LastTransactionStatusRequestIndicator["StatusAndReceipt"] = 2] = "StatusAndReceipt";
})(LastTransactionStatusRequestIndicator = exports.LastTransactionStatusRequestIndicator || (exports.LastTransactionStatusRequestIndicator = {}));

var StopProcessingRequestIndicator;

(function (StopProcessingRequestIndicator) {
  StopProcessingRequestIndicator[StopProcessingRequestIndicator["NoAction"] = 0] = "NoAction";
  /**
   * Stops processing transactions on the given
   * terminal ID
   */

  StopProcessingRequestIndicator[StopProcessingRequestIndicator["StopProcessing"] = 1] = "StopProcessing";
  /**
   * Stop listening for transactions on the given
   * terminal ID
   */

  StopProcessingRequestIndicator[StopProcessingRequestIndicator["StopListening"] = 2] = "StopListening";
  /***
   * Start Listening for transactions again on the
   * given terminal ID
   */

  StopProcessingRequestIndicator[StopProcessingRequestIndicator["StartListening"] = 3] = "StartListening";
})(StopProcessingRequestIndicator = exports.StopProcessingRequestIndicator || (exports.StopProcessingRequestIndicator = {}));

var TaxIndicator;

(function (TaxIndicator) {
  TaxIndicator[TaxIndicator["NotProvided"] = 0] = "NotProvided";
  TaxIndicator[TaxIndicator["TaxIncluded"] = 1] = "TaxIncluded";
  TaxIndicator[TaxIndicator["NonTaxableTransaction"] = 2] = "NonTaxableTransaction";
})(TaxIndicator = exports.TaxIndicator || (exports.TaxIndicator = {}));
/**
 * The status indicator sent in the
 * DeviceStatus response string
 */


var TerminalStatus;

(function (TerminalStatus) {
  TerminalStatus[TerminalStatus["NotActive"] = 0] = "NotActive";
  TerminalStatus[TerminalStatus["IdleNoPinPad"] = 1] = "IdleNoPinPad";
  TerminalStatus[TerminalStatus["Processing"] = 2] = "Processing";
  TerminalStatus[TerminalStatus["IdlePinPadError"] = 3] = "IdlePinPadError";
  TerminalStatus[TerminalStatus["IdlePinPadOk"] = 4] = "IdlePinPadOk";
  TerminalStatus[TerminalStatus["CheckingPinPad"] = 5] = "CheckingPinPad";
  TerminalStatus[TerminalStatus["TerminalIdNotFound"] = 99] = "TerminalIdNotFound";
})(TerminalStatus = exports.TerminalStatus || (exports.TerminalStatus = {}));

exports.TerminalStatusLookupMap = util_1.reverseLookupMapForEnum(TerminalStatus);
/**
 * Used for payment requests that are not
 * using the ExpandedRequest new format.
 * Expanded request messages are always
 * Subtype 8.
 */

var TransactionSubtype;

(function (TransactionSubtype) {
  TransactionSubtype["OldFormat"] = "0";
  TransactionSubtype["CurrentFormat"] = "1";
  TransactionSubtype["OldFormatWithCompanyName"] = "P";
  TransactionSubtype["CurrentFormatWithCompanyName"] = "R";
  TransactionSubtype["OldFormatRemotePinPadRequest"] = "2";
  TransactionSubtype["CurrentFormatRemotePinPadRequest"] = "3";
  TransactionSubtype["GiftCardFormat"] = "4";
  TransactionSubtype["VerifiedVisaFormat"] = "5";
  TransactionSubtype["EmexTransactionFormat"] = "6";
  TransactionSubtype["ExpandedFormat"] = "7";
  TransactionSubtype["ExpandedRequestSubtype"] = "8";
})(TransactionSubtype = exports.TransactionSubtype || (exports.TransactionSubtype = {}));

var TransactionType;

(function (TransactionType) {
  // Credit Card Types
  // standard purchase request (Default)
  TransactionType["CreditCardPurchase"] = "00"; // pre-authorization request

  TransactionType["CreditCardPreAuth"] = "10"; // store and forward

  TransactionType["CreditCardPurchaseSAF"] = "20"; // purchase correction

  TransactionType["CreditCardPurchaseCorrection"] = "30"; // credit card refund

  TransactionType["CreditCardRefund"] = "40"; // credit card refund correction

  TransactionType["CreditCardRefundCorrection"] = "50"; // Debit Card Types
  // standard purchase

  TransactionType["DebitCardPurchase"] = "01"; // debit purchase correction

  TransactionType["DebitCardPurchaseCorrection"] = "31"; // debit refund

  TransactionType["DebitCardRefund"] = "41"; // debit refund correction

  TransactionType["DebitCardRefundCorrection"] = "51"; // device status

  TransactionType["DeviceStatus"] = "XO"; // gift card - no partial redemption, balance
  // must be greater than amount

  TransactionType["GiftCardRedemptionNoNSF"] = "83"; // gift card - redemption allowed even if requested
  // amount is greater than balance - must charge another
  // payment method for balance due

  TransactionType["GiftCardRedemption"] = "33"; // loyalty card

  TransactionType["LoyaltyCardType"] = "04"; // unknown card type

  TransactionType["UnknownCardType"] = "0U"; // Purchase - Prompt User for Card Type

  TransactionType["GeneralCardType"] = "0G";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));